import _ from 'lodash'

export default {
  viewType: 'form',
  module: '/feature/',
  callBackAction: 'copyFeatureAndTestCase',
  params: {},
  okAction: 'copyFeatureAndTestCase',
  toolbar: {},
  needFetchFillInfo: false,
  view: {
    showCancelBtn: false,
    labelPosition: 'right',
    labelWidth: '225px',
    content: [
      {
        $id: 'baseProductId',
        $type: 'select',
        label: '源版本',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          return value
        },
        rules: [
          {
            notEmpty: '源版本'
          }
        ]
      },
      {
        $id: 'newProductId',
        $type: 'select',
        label: '复制到目标版本',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          return value
        },
        rules: [
          {
            notEmpty: '复制到目标版本'
          }
        ]
      }
    ]
  }
}
